import React, {ReactElement, useContext} from "react";
import CrossIcon from './icons/svg/cross.svg?react'

import './Sidebar.scss'
import AppContext, {SidebarType} from "../context/AppContext";

type Props = {
  type: string
  title?: String
  children: ReactElement | ReactElement[]
}

export default (props: Props) => {
  const {
    setSidebar,
  } = useContext(AppContext)

  const onClose = (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    setSidebar(SidebarType.None)
  }

  return (
    <div className={`sidebar ${props.type}-sidebar`}>
      <div className="sidebar-frame-54">
        <div className="sidebar-frame-53">
          {props.title && (
            <span className="sidebar-title">{props.title}</span>
          )}
          <button className="sidebar-btn-close" onClick={onClose}>
            <CrossIcon/>
          </button>
        </div>
      </div>

      <div className="sidebar-content">
        {props.children}
      </div>
    </div>
  )
}